export default "__VITE_ASSET__CktZotrk__"